import React, { useContext } from 'react';
import { ReportHeroModel } from './ReportHero';

import HeroData from './HeroData';
import { Breadcrumbs, FullPageEmbeddedMediaElement, MetadataContext, ResponsiveImage, Stack } from '@/components';

export type ClassicLetterboxType = ReportHeroModel;

const ClassicLetterbox = (data: ClassicLetterboxType) => {
  const { heroImage, heroEmbedVideo, useHeroImageHeightForEmbedVideo, breadcrumbs } = data.props;
  const { isPublic, pageType } = useContext(MetadataContext);

  let dispalayHeroData = true;
  if (
    isPublic &&
    !(
      (data.props.intro && data.props.intro.length > 0) ||
      (data.props.authors && data.props.authors.length > 0) ||
      (data.props.readTime && data.props.readTime != '0')
    )
  ) {
    dispalayHeroData = false;
  }

  return (
    <div className="flex w-full flex-col">
      {heroEmbedVideo || isPublic ? (
        <FullPageEmbeddedMediaElement
          videoEmbedCode={heroEmbedVideo}
          coverImage={{ ...heroImage, mobileImage: isPublic ? undefined : heroImage?.mobileImage }}
          useHeroImageHeightForEmbedVideo={useHeroImageHeightForEmbedVideo}
        />
      ) : heroImage ? (
        <>
          {heroImage.desktopImage && (
            <ResponsiveImage
              className="hidden md:block print:block"
              image={heroImage.desktopImage}
              widths={
                pageType === 'legacyReportPage'
                  ? { xs: 768, sm: 1024, md: 1440, lg: 1904, xl: 2560 }
                  : { md: 1440, lg: 1904, xl: 2560 }
              }
              preload
            />
          )}
          {heroImage.mobileImage && (
            <ResponsiveImage
              className="md:hidden print:hidden"
              image={heroImage.mobileImage}
              widths={{ xs: 550, sm: 768 }}
              preload
            />
          )}
        </>
      ) : null}

      <Breadcrumbs className="py-3" data={breadcrumbs} />

      {dispalayHeroData && (
        <Stack className="container flex flex-col pt-8 pb-8 lg:pt-16 lg:pb-16">
          <HeroData {...data} />
        </Stack>
      )}
    </div>
  );
};

export default ClassicLetterbox;
